import {Marker} from "react-leaflet";
import {renderToStaticMarkup} from "react-dom/server";
import L from "leaflet";
import {MapArrowUp} from "reicon-react";
import {simulatedPosition} from "../data/current-location";

const locationIcon = L.divIcon({
  className: 'current-location-marker',
  iconSize: [34, 34],
  iconAnchor: [17, 17],
  html: `<span class="current-location-cursor"><span class="current-location-tooltip">Estás aquí</span>${renderToStaticMarkup(
    <MapArrowUp size={22} weight="Filled" color="white" aria-hidden="true" focusable="false"/>
  )}</span>`,
})

const CurrentLocation = () => (
  <Marker
    position={simulatedPosition}
    icon={locationIcon}
    interactive={false}
    zIndexOffset={10000}
  />
);

export default CurrentLocation;
